import { Route } from 'react-router-dom';

import { Constraints } from './constraints.component';

export function ApplicationsConstraintsRoutes() {
    return (
        <Route path='constraints'>
            <Route
                path='constraints'
                element={<Constraints />}
            />
        </Route>
    );
}
